import { Link } from "@inertiajs/react";
import App from "../layouts/app";
import { Pen } from 'lucide-react';
import PageTitle from "../components/PageTitle";
import ContentWrapper from "../components/ContentWrapper";
import clsx from "clsx";
import { Opponent } from "./Opponents";

export enum Status {
    Draft = "Draft",
    Published = "Published",
    Archived = "Archived",
}

export interface Match {
    id: number;
    opponent_id: number;
    score_team: number | null;
    score_opponent: number | null;
    opponent: Opponent;
    date: string;
    status: string;
    url: string;
    best_of: number;
    event: number;
}

export default function Matches({ matches: { data: matches } }: { matches: { data: Match[] } }) {

    const thClasses = "font-medium px-4 py-2 text-gray-500";
    const tdClasses = "border-t border-gray-200 px-4 py-2";

    return (
        <App>
            <PageTitle title="Matches" />
            <ContentWrapper>
                <div className="flex justify-between items-center">
                    <h2 className="text-lg">Matches</h2>
                    <Link href={`/admin/matches/add`} className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-md">Add Match</Link>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th className={clsx([thClasses, 'text-left'])}>Match</th>
                            <th className={clsx([thClasses, 'text-left'])}>Score</th>
                            <th className={clsx([thClasses, 'text-left'])}>Event</th>
                            <th className={clsx([thClasses, 'text-left'])}>Date</th>
                            <th className={clsx([thClasses, 'text-left'])}>Status</th>
                            <th className={clsx([thClasses, 'text-left'])}>Best Of</th>
                            <th className={clsx([thClasses, 'text-right'])}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {matches.map((match) => (
                            <tr key={match.id}>
                                <td className={tdClasses}>LAG vs {match.opponent.name}</td>
                                <td className={tdClasses}>{match.score_team} : {match.score_opponent}</td>
                                <td className={tdClasses}>{match.event}</td>
                                <td className={tdClasses}>{match.date}</td>
                                <td className={tdClasses}>{match.status}</td>
                                <td className={tdClasses}>{match.best_of}</td>
                                <td className={tdClasses}>
                                    <div className="flex justify-end">

                                        <Link href={`/admin/matches/${match.id}`} className="text-indigo-600 hover:text-indigo-800">
                                            Edit
                                        </Link>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </ContentWrapper>
        </App >
    )
}